import React, { Component } from 'react'
import { Text } from 'react-localizer'
import { EraToGmMapping } from '../../data/EraToGmMapping'

import ResultsContainer from './ResultsContainer'
import { Table } from 'react-bootstrap'
import '../../css/gmblocking.css'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import 'react-notifications/lib/notifications.css'
import { getCurrentEraData } from '../../helper/EraDataHelper'

class GmBlockingThreshold extends Component {

  defaulLevel = 10
  rateDefaultValue = 190

  constructor (props) {
    super(props)

    // Fetch local storage if set
    const gmStorage = localStorage.getItem('gm') ? localStorage.getItem('gm') : 0
    const levelStorage = localStorage.getItem('level') ? localStorage.getItem('level') : this.defaulLevel

    /**
     *
     * @type {{P1Storage, P2Storage, P3Storage, P4Storage, P5Storage}}
     */
    const rates = {}

    // Generates variables dynamically
    for (let place = 1; place <= 5; place++) {
      rates[`P${place}Storage`] = localStorage.getItem(`rateP${place}`) ? localStorage.getItem(`rateP${place}`) : this.rateDefaultValue
    }

    //define initial state
    this.state = {
      gmChoosen: gmStorage,
      levelChoosen: levelStorage,
      rateP1Choosen: rates.P1Storage,
      rateP2Choosen: rates.P2Storage,
      rateP3Choosen: rates.P3Storage,
      rateP4Choosen: rates.P4Storage,
      rateP5Choosen: rates.P5Storage,
      selectOptionsAllGm: [],
      selectOptionsAllLevels: []
    }
  }

  static setLocalStorage (itemName, value) {
    localStorage.setItem(itemName, value)
  }

  /**
   * Build list of levels
   * @param gmName
   * @returns {Promise<Array>}
   */
  static buildGmLevels (gmName) {
    let selectOptionsAllLevelsArray = []
    // Looking for which Era corresponds to the selected GM to build rows
    for (let item of EraToGmMapping) {
      for (let gm of item.gms) {
        if (gm === gmName) {
          // import dynamically eraData wanted
          return new Promise(resolve => resolve(getCurrentEraData(item.era)))
            .then(eraData => {
              const length = eraData.length
              // build the option array
              for (let i = 1; i <= length; i++) {
                selectOptionsAllLevelsArray.push(<option key={i} value={i}> {i}</option>)
              }
              return selectOptionsAllLevelsArray
            })
        }
      }
    }
  }

  static toggleVisibilityInfo () {
    const currentInfoDivStyle = document.getElementsByClassName('blocking-description')[0].style.display

    if (currentInfoDivStyle === 'none') {
      document.getElementsByClassName('blocking-description')[0].style.display = 'block'
      document.getElementsByClassName('blocking-description')[1].style.display = 'none'
    } else {
      document.getElementsByClassName('blocking-description')[0].style.display = 'none'
      document.getElementsByClassName('blocking-description')[1].style.display = 'block'
    }
  }

  static handleNotification (event) {
    NotificationManager.success(event)
  }

  handleRateDownButton (event, id) {
    document.getElementById(id).stepDown()
    // simulate the call onChange
    this.handleRankChanged({target: {value: document.getElementById(id).value}}, parseInt(id.slice(-1), 10))
  }

  handleRateUpButton (event, id) {
    document.getElementById(id).stepUp()
    this.handleRankChanged({target: {value: document.getElementById(id).value}}, parseInt(id.slice(-1), 10))
  }

  componentDidMount () {

    // build list of GM
    let selectOptionsAllGmArray = []
    let backgroundColor
    selectOptionsAllGmArray.push(<option hidden key={0} value={0}><Text>gmBlockingThreshold.select</Text></option>)
    for (let item of EraToGmMapping) {
      backgroundColor = item.color
      for (let gm of item.gms) {
        let key = `gms.${gm}`
        selectOptionsAllGmArray.push(<option key={gm} value={gm} style={{backgroundColor: backgroundColor, color: 'white'}}><Text>{key}</Text></option>)
      }
    }

    // build list of levels - check user have an existing key
    const frTranslation = require('../../locale/languages/fr')
    if (this.state.gmChoosen && frTranslation.gms[this.state.gmChoosen]) {
      GmBlockingThreshold.buildGmLevels(this.state.gmChoosen)
        .then(selectOptionsAllLevelsArray => {
          this.setState({
            selectOptionsAllGm: selectOptionsAllGmArray,
            selectOptionsAllLevels: selectOptionsAllLevelsArray
          })
        })
    } else {
      this.setState({
        selectOptionsAllGm: selectOptionsAllGmArray,
        selectOptionsAllLevels: []
      })
    }
  }

  storeLevelChoosen ({levelChoosen, item}) {
    new Promise(resolve => resolve(getCurrentEraData(item.era)))
      .then(eraData => {
        // build the option array
        if (levelChoosen >= eraData.length) {
          levelChoosen = eraData.length - 20 //to stay on higher levels
          GmBlockingThreshold.setLocalStorage('level', levelChoosen)
        }
      })
  }

  handleGmChanged (event) {
    const gmChoosen = event.target.value
    // check that level wanted exists for this EraToGmMapping
    let levelChoosen = this.state.levelChoosen
    for (let item of EraToGmMapping) {
      for (let gm of item.gms) {
        if (gm === gmChoosen) {
          // check if level provided exists
          this.storeLevelChoosen({levelChoosen, item})
        }
      }
    }

    localStorage.removeItem('hightLightedLevels')
    GmBlockingThreshold.setLocalStorage('gm', gmChoosen)
    GmBlockingThreshold.buildGmLevels(gmChoosen)
      .then(selectOptionsAllLevels => {
        this.setState({
          gmChoosen: gmChoosen,
          levelChoosen: levelChoosen,
          selectOptionsAllLevels: selectOptionsAllLevels
        })
      })

  }

  handleRankChanged (event, rank) {

    GmBlockingThreshold.setLocalStorage(`rateP${rank}`, event.target.value)
    const newState = {}
    newState[`rateP${rank}Choosen`] = event.target.value
    this.setState(newState)
  }

  handleLevelChanged (event) {
    GmBlockingThreshold.setLocalStorage('level', event.target.value)
    this.setState({
      levelChoosen: event.target.value,
    })
  }

  render () {
    return (
      <div>
        <NotificationContainer/>
        <div className="filters">
          <form className="App-form">
            <div className="App-form-group">
              <select name={'gmName'}
                      value={this.state.gmChoosen}
                      id="gmName"
                      onChange={(event) => this.handleGmChanged(event)}>
                {this.state.selectOptionsAllGm}
              </select>
            </div>
          </form>
        </div>
        <div className="blocking-description" onClick={() => GmBlockingThreshold.toggleVisibilityInfo()}>
          <span className={'title-info'}>
            <Text>gmBlockingThreshold.info.title</Text>
          </span><span className={'title-info-hide'}>
          <Text>gmBlockingThreshold.info.expand</Text>
        </span>
        </div>
        <div className="blocking-description" onClick={() => GmBlockingThreshold.toggleVisibilityInfo()} style={{display: 'none'}}>
          <span className={'title-info'}>
            <Text>gmBlockingThreshold.info.title</Text>
          </span><span className={'title-info-hide'}>
            <Text>gmBlockingThreshold.info.reduce</Text>
          </span>
          <ul>
            <li><Text>gmBlockingThreshold.info.describeColumns</Text></li>
            <li>
              <span className="unlockable">
                <Text>gmBlockingThreshold.info.describeRed.unlockableStart</Text>
                <b><Text>gmBlockingThreshold.info.describeRed.unlockableBold</Text></b>
                <Text>gmBlockingThreshold.info.describeRed.unlockableEnd</Text>
              </span>
              <Text>gmBlockingThreshold.info.describeRed.middle</Text>
              <span className="lockable">
                <Text>gmBlockingThreshold.info.describeRed.lockable</Text>
              </span>
            </li>

            <li><span className="lockable"><Text>gmBlockingThreshold.info.describeGreen</Text></span></li>
            <li><span className="highlight describeClickOnLine"><Text>gmBlockingThreshold.info.describeClickOnLine</Text></span></li>
            <li>
              <Text>gmBlockingThreshold.info.describeCopy.beforeImg</Text>
              <span className="glyphicon glyphicon-share iconCopyClipboardInfos"/>
              <Text>gmBlockingThreshold.info.describeCopy.afterImg</Text>
              <b><Text>gmBlockingThreshold.info.describeCopy.promoteExample</Text></b>
            </li>
          </ul>

        </div>
        <div className="results">
          <Table condensed responsive>
            <thead>
            <tr>
              <th scope={'col'}><Text>gmBlockingThreshold.th.level</Text></th>
              <th scope={'col'} rowSpan={2}><Text>gmBlockingThreshold.th.maxFp</Text></th>
              <th scope={'col'} className={'rank'}><Text>gmBlockingThreshold.th.p1</Text></th>
              <th scope={'col'} className={'rank'}><Text>gmBlockingThreshold.th.p2</Text></th>
              <th scope={'col'} className={'rank'}><Text>gmBlockingThreshold.th.p3</Text></th>
              <th scope={'col'} className={'rank'}><Text>gmBlockingThreshold.th.p4</Text></th>
              <th scope={'col'} className={'rank'}><Text>gmBlockingThreshold.th.p5</Text></th>
              <th scope={'col'} rowSpan={2}>
                <Text>gmBlockingThreshold.th.p1To5.line1</Text><br/>
                <Text>gmBlockingThreshold.th.p1To5.line2</Text><br/>
                <Text>gmBlockingThreshold.th.p1To5.line3</Text>
              </th>
            </tr>
            <tr>
              <th>
                <select name={'gmLevels'} className={'data-hj-allow'}
                        value={this.state.levelChoosen}
                        id="level"
                        onChange={(event) => this.handleLevelChanged(event)}>
                  {null !== this.state.selectOptionsAllLevels && this.state.selectOptionsAllLevels}
                </select>
              </th>
              <th className={'rate'}>
                <button onClick={(event) => this.handleRateDownButton(event, 'rateP1')}>-</button>
                <input id={'rateP1'} type={'number'} min={130} max={200} defaultValue={this.state.rateP1Choosen}
                       className={'data-hj-allow'}
                       step={0.5} onChange={(event) => this.handleRankChanged(event, 1)}/>
                <button onClick={(event) => this.handleRateUpButton(event, 'rateP1')}>+</button>
              </th>
              <th className={'rate'}>
                <button onClick={(event) => this.handleRateDownButton(event, 'rateP2')}>-</button>
                <input id={'rateP2'} type={'number'} min={130} max={200} defaultValue={this.state.rateP2Choosen}
                       className={'data-hj-allow'}
                       step={0.5} onChange={(event) => this.handleRankChanged(event, 2)}/>
                <button onClick={(event) => this.handleRateUpButton(event, 'rateP2')}>+</button>
              </th>
              <th className={'rate'}>
                <button onClick={(event) => this.handleRateDownButton(event, 'rateP3')}>-</button>
                <input id={'rateP3'} type={'number'} min={130} max={200} defaultValue={this.state.rateP3Choosen}
                       className={'data-hj-allow'}
                       step={0.5} onChange={(event) => this.handleRankChanged(event, 3)}/>
                <button onClick={(event) => this.handleRateUpButton(event, 'rateP3')}>+</button>
              </th>
              <th className={'rate'}>
                <button onClick={(event) => this.handleRateDownButton(event, 'rateP4')}>-</button>
                <input id={'rateP4'} type={'number'} min={130} max={200} defaultValue={this.state.rateP4Choosen}
                       className={'data-hj-allow'}
                       step={0.5} onChange={(event) => this.handleRankChanged(event, 4)}/>
                <button onClick={(event) => this.handleRateUpButton(event, 'rateP4')}>+</button>
              </th>
              <th className={'rate'}>
                <button onClick={(event) => this.handleRateDownButton(event, 'rateP5')}>-</button>
                <input id={'rateP5'} type={'number'} min={130} max={200} defaultValue={this.state.rateP5Choosen}
                       className={'data-hj-allow'}
                       step={0.5} onChange={(event) => this.handleRankChanged(event, 5)}/>
                <button onClick={(event) => this.handleRateUpButton(event, 'rateP5')}>+</button>
              </th>
            </tr>
            </thead>

            {null !== this.state.gmChoosen &&
            <ResultsContainer choices={this.state} notification={(event) => GmBlockingThreshold.handleNotification(event)}/>}

          </Table>
        </div>
      </div>
    )
  }
}

export default GmBlockingThreshold



// WEBPACK FOOTER //
// ./src/components/GmBlockingThreshold/GmBlockingThreshold.js